// Reads a map pin out of whatever an owner pastes: "33.6955, 73.0129", a
// Google Maps link with @lat,lng or ?q=lat,lng / ?query=lat,lng, or a
// /dir/ destination. Null when there's no usable coordinate pair.
export function parseMapPin(raw: string): { lat: number; lng: number } | null {
  const s = (raw ?? '').trim()
  if (!s) return null
  const pair = /(-?\d{1,3}\.\d+)\s*,\s*(-?\d{1,3}\.\d+)/
  const patterns = [
    /@(-?\d{1,3}\.\d+),(-?\d{1,3}\.\d+)/, // …/@33.69,73.01,17z
    /!3d(-?\d{1,3}\.\d+)!4d(-?\d{1,3}\.\d+)/, // place data blob
    /[?&](?:q|query|destination|ll)=(-?\d{1,3}\.\d+)(?:%2C|,)(-?\d{1,3}\.\d+)/i,
    pair,
  ]
  for (const re of patterns) {
    const m = re.exec(s)
    if (!m) continue
    const lat = Number(m[1])
    const lng = Number(m[2])
    if (Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && !(lat === 0 && lng === 0)) return { lat, lng }
  }
  return null
}
